import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { colors } from '@startengine/design-system.theme.main';

export const BannerGrid = styled(Grid)(({ theme, color }) => ({
  backgroundColor: color,
  color: colors.white,
  padding: '16px 33px',
  justifyContent: 'center',
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    padding: '16px 0',
  },
}));

export const TestGrid = styled(Box)(({ theme }) => ({
  backgroundColor: '#FFEAD6',
  color: '#5C2D00',
  padding: '16px 33px',
  justifyContent: 'center',
  display: 'flex',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: '16px 0',
  },
}));
